import { Link } from "react-router-dom";

/**
 * Brand mark: the Purvodaya Solar logo lockup.
 *
 * Variants:
 *  - "full"    → logo image + wordmark "Purvodaya Solar"   (default, ~32px tall)
 *  - "compact" → logo image only, square                    (sidebars / app bars)
 *  - "stacked" → logo image above the wordmark              (splash / login hero)
 */
export default function Brand({ variant = "full", to = "/", className = "", size = 32, testid = "brand" }) {
  const img = (
    <img
      src="/purvodaya-logo.png"
      alt="Purvodaya Solar"
      style={{ height: size, width: size }}
      className="object-contain flex-shrink-0"
      draggable={false}
    />
  );

  if (variant === "compact") {
    return (
      <Link to={to} data-testid={testid} className={"inline-flex items-center " + className}>
        {img}
      </Link>
    );
  }

  if (variant === "stacked") {
    return (
      <Link to={to} data-testid={testid} className={"inline-flex flex-col items-center gap-2 " + className}>
        <img
          src="/purvodaya-logo.png"
          alt="Purvodaya Solar"
          className="object-contain"
          style={{ height: size * 2.4, width: size * 2.4 }}
          draggable={false}
        />
        <div className="font-display font-bold leading-none">
          <span style={{ color: "#1B5E20" }}>Purvodaya</span>{" "}
          <span style={{ color: "#F39C12" }}>SOLAR</span>
        </div>
      </Link>
    );
  }

  // full (default)
  return (
    <Link to={to} data-testid={testid} className={"inline-flex items-center gap-2.5 " + className}>
      {img}
      <span className="font-display font-bold leading-none whitespace-nowrap" style={{ fontSize: Math.max(14, size * 0.5) }}>
        <span style={{ color: "#1B5E20" }}>Purvodaya</span>{" "}
        <span style={{ color: "#F39C12" }}>SOLAR</span>
      </span>
    </Link>
  );
}
